var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mobile-footer-panel" },
    [
      _c("ProductNavRow", {
        attrs: { active: _vm.cockfightActive },
        on: {
          "select-cockfight": function ($event) {
            return _vm.$emit("select-cockfight")
          },
        },
      }),
      _c("div", { staticClass: "mobile-footer-panel__wallet-row" }, [
        _c("div", { staticClass: "mobile-footer-panel__balance" }, [
          _c(
            "span",
            { staticClass: "mobile-footer-panel__balance-amount relative" },
            [
              _vm._v(" " + _vm._s(_vm.currencySymbol) + " "),
              _c("animated-amount", {
                attrs: {
                  value: _vm.balanceValue,
                  formatValue: _vm.formatAmount,
                  duration: 500,
                },
              }),
              _c("Transition", { attrs: { name: "fade" } }, [
                _vm.futureDiff
                  ? _c(
                      "div",
                      { staticClass: "mobile-footer-panel__future-diff" },
                      [_vm._v("+ " + _vm._s(_vm.userFutureDiff))]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "mobile-footer-panel__logo-slot" },
          [_c("Logo")],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }